import type { PrecomputedBiothreatSignal } from "./types"

interface GdeltMetaWithSummary {
  cluster_member_title_summary?: string | null
}

export const getClusterMemberTitleSummary = (
  cluster: PrecomputedBiothreatSignal
): string | undefined => {
  const meta = cluster.gdelt_meta as GdeltMetaWithSummary | null | undefined
  const summary = meta?.cluster_member_title_summary
  return typeof summary === "string" && summary.length > 0 ? summary : undefined
}
